export const FETCH_SPONSORS = "FETCH_SPONSORS";
export const FETCH_SPONSORS_PENDING = "FETCH_SPONSORS_PENDING";
export const FETCH_SPONSORS_FULFILLED = "FETCH_SPONSORS_FULFILLED";
export const FETCH_SPONSORS_REJECTED = "FETCH_SPONSORS_REJECTED";
